import { getCode } from '@core/utils/codes'
import UserToken from '@admin/tokens/user'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Recipient extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    onDone: PropTypes.func
  }

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault()
      }
    })
  }

  _getDefault() {
    return {
      code: getCode(10),
      strategy: 'user'
    }
  }

  _getForm() {
    const { config } = this.state
    return {
      title: 't(Recipient)',
      cancelSvg: 'chevron_left',
      onCancel: this._handleBack,
      onChange: this._handleChange,
      onSuccess: this._handleDone,
      saveText: 'Add',
      sections: [
        {
          fields: [
            { name: 'code', type: 'hidden', value: config.code },
            { label: 't(Recipient)', type: 'segment', fields: [
              { name: 'strategy', type: 'radiogroup', options: [
                { value: 'user', text: 't(Dial a user)' },
                { value: 'number', text: 't(Dial a phone number)' }
              ], defaultValue: config.strategy },
              this._getStrategy()
            ] }
          ]
        }
      ]
    }
  }

  _getStrategy() {
    const { config } = this.state
    if(config.strategy === 'user') {
      return { name: 'user_id', type: 'lookup', required: true, prompt: 't(Choose User)', endpoint: '/api/admin/users', filter: { is_active: { $eq: true } }, valueKey: 'id', textKey: 'full_name', format: UserToken, defaultValue: config.user_id }
    } else if(config.strategy === 'number') {
      return { name: 'number', type: 'phonefield', required: true, placeholder: 't(Enter Number)', defaultValue: config.number }
    }
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone() {
    const { config } = this.state
    this.props.onDone(config)
    this.context.form.pop()
  }

}

export default Recipient
